import api from "./index";

export async function getHistoric(params) {
  return api.get(`/attendances/me`, { params: params });
}
